import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

import Years from '../../Assets/Icons/Home/years.svg';
import Trash from '../../Assets/Icons/Home/trash.svg';
import Recycle from '../../Assets/Icons/Home/recycle.svg';
import Orders from '../../Assets/Icons/Home/orders.svg';
import Employees from '../../Assets/Icons/Home/employees.svg';
import Partners from '../../Assets/Icons/Home/partners.svg';
import Country from '../../Assets/Icons/Home/country.svg';
import Centers from '../../Assets/Icons/Home/centers.svg';

import 'swiper/css';
import 'swiper/css/navigation';
import {
  ArrowLeftOutlined,
  LeftOutlined,
  RightOutlined,
  SwapLeftOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';

const NumbersSlider = () => {
  const [renderMe, setRenderMe] = useState(false);

  const { t } = useTranslation();
  const items = t('home.numbers.items', { returnObjects: true });

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const { language } = useSelector((state) => state.lang);
  //   const dir = language === 'ar' ? 'rtl' : 'ltr';

  const [dir, setDir] = useState(language === 'ar' ? 'rtl' : 'ltr');

  const isRTL = dir === 'rtl';

  useEffect(() => {
    setDir(language === 'ar' ? 'rtl' : 'ltr');
  }, [language]);

  const images = [
    Years,
    Trash,
    Recycle,
    Orders,
    Employees,
    Centers,
    Partners,
    Country,
    Centers,
  ];

  return (
    <section className="home__numbers">
      <h2>{t('home.numbers.title')}</h2>

      <div style={{ position: 'relative' }}>
        <Swiper
          key={isRTL ? 'rtl' : 'ltr'} //
          dir={dir}
          isRTL={isRTL}
          modules={[Navigation, Autoplay]}
          autoplay={{
            delay: 3000, // 3 seconds
            disableOnInteraction: false, // Keeps autoplay after user interacts
          }}
          spaceBetween={1}
          slidesPerView={2}
          breakpoints={{
            1024: { slidesPerView: 4 },
          }}
          onBeforeInit={(swiper) => {
            if (typeof swiper.params.navigation !== 'boolean') {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }
          }}
          onInit={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index} dir={dir} isRTL={isRTL}>
              <div className="home__numbers-item">
                <img src={images[index]} alt={item.label} loading="lazy" />
                <h3>{item.value}</h3>
                <p>{item.label}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation Buttons */}
        <button
          className="home_button--left"
          ref={prevRef}
          style={{
            backgroundColor: isBeginning ? '#DFDFDF' : '#011a3e',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: isBeginning ? 'not-allowed' : 'pointer',
            // zIndex: 10,
          }}
        >
          <LeftOutlined />
        </button>

        <button
          className="home_button--right"
          ref={nextRef}
          style={{
            backgroundColor: isEnd ? '#DFDFDF' : '#011a3e',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: isEnd ? 'not-allowed' : 'pointer',
            // zIndex: 10,
          }}
        >
          <RightOutlined />
        </button>
      </div>
    </section>
  );
};

export default NumbersSlider;
